import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLang } from '@/lib/LanguageContext';
import { PATH_LANG } from '@/lib/detectLanguage';

// Country URLs (/es/, /mx/, /us/...) fix the page language; other pages use the visitor's language.
export default function LangPathSync() {
  const { pathname } = useLocation();
  const { setPathLang } = useLang();
  const cc = pathname.split('/')[1];
  useEffect(() => { setPathLang(PATH_LANG[cc] || null); }, [cc]);
  return null;
}